<template>
	<ul class="list">
		<li v-for="item in list" @click="toDetail(item)">
			<div class="list-img">
				<img :src="item.bannerFileUrl" />
			</div>
			<div class="list-r">
				<div class="list-title">{{item.vacationName}}</div>
				<div class="list-company">{{item.startCompayName}}</div>
				<div class="list-scope">招募范围：{{item.recruitNames}}</div>
				<div class="list-time">报名时间：{{item.recruitStartTime | datefmt('yyyy-MM-DD')}}至{{item.recruitEndTime | datefmt('yyyy-MM-DD')}}</div>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'Activity',
		props: {
			list: {
				type: Array,
				value: []
			}
		},
		methods: {
			toDetail(item){
				console.log('33333333333')
				this.$router.push({
					path: `/activity/activityDetail/${item.id}`
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.list{
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		li{
			display: flex;
			width: 530px;
			background: #fff;
			padding: 20px 24px;
			margin-top: 20px;
			border-radius: 5px;
			box-sizing: border-box;
			overflow: hidden;
			cursor: pointer;
			font-size: 13px;
			color: #999;
			line-height: 24px;
			.list-img{
				margin-right: 20px;
				img{
					width: 240px;
					height: 140px;
				}
			}
			.list-title{
				margin-top: 10px;
				height: 48px;
				font-weight: 500;
				font-size: 18px;
				color: #37383c;
				letter-spacing: 1.29px;
				line-height: 24px;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				overflow: hidden;
				-webkit-box-orient: vertical;
			}
			.list-company{
				color: #666;
			}
			.list-time,.list-scope{
				font-size: 12px;
			}
		}
		li:hover{
			box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
		}
	}
	// .list{
	// 	li{
	// 		display: flex;
	// 		padding: 10px 0;
	// 		border-bottom: 1px solid #f3f3f3;
	// 		color: #999;
	// 		line-height: 24px;
	// 		.list-img{
	// 			margin-right: 20px;
	// 			img{
	// 				width: 320px;
	// 				height: 144px;
	// 			}
	// 		}
	// 		.list-title{
	// 			margin-top: 10px;
	// 			height: 48px;
	// 			font-weight: 500;
	// 			font-size: 18px;
	// 			color: #37383c;
	// 			letter-spacing: 1.29px;
	// 			line-height: 24px;
	// 			text-overflow: ellipsis;
	// 			display: -webkit-box;
	// 			-webkit-line-clamp: 2;
	// 			overflow: hidden;
	// 			-webkit-box-orient: vertical;
	// 		}
	// 		.list-company{
	// 			color: #666;
	// 		}
	// 		.list-time,.list-scope{
	// 			font-size: 12px;
	// 		}
	// 	}
	// }
</style>
